import FiltersPanel from './FiltersPanel'

export default FiltersPanel
